import { FC } from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'react-hot-toast';

import Card from '@components/elements/Card';
import { LinkIcon } from '@components/elements/Icons/LinkIcon';
import CompanyApprovalList from '@components/modules/Admin/Approval/CompanyApprovalList';
import CompanyMemberList from '@components/modules/Admin/Member/CompanyMemberList';

import { useAuth } from '@hooks/Auth';

const AdminApprovalPage: FC = () => {
  const { company } = useAuth();
  return (
    <div className="h-screen overflow-x-hidden overflow-y-scroll bg-fixed bg-blue-light">
      <div className="mx-4 mt-16">
        <h1 className="mb-4 text-4xl text-white whitespace-pre-line">
          {`Approve & reject join requests`}
        </h1>
      </div>
      <div className="flex flex-col gap-4 mx-auto xl:gap-8 lg:flex-row">
        <div className="w-full lg:min-h-screen lg:sticky lg:top-0 lg:w-108">
          {company && (
            <div className="flex flex-col mx-4 my-4 space-y-2 lg:mr-0 lg:ml-4">
              <h2 className="text-white uppercase">COMPANY ID</h2>

              <div className="p-4 text-black bg-yellow">
                <CopyToClipboard
                  text={company?.companyID}
                  onCopy={() => toast('Copied link to clipboard.')}
                >
                  <div role="button" className="flex justify-between">
                    {company?.companyID}{' '}
                    <LinkIcon className="w-4 h-4 opacity-80" />
                  </div>
                </CopyToClipboard>
                <span className="text-sm text-gray-darkest">
                  Share this ID to let users join the company
                </span>
              </div>
            </div>
          )}
          <div className="flex flex-col mx-4 my-4 space-y-2 lg:mr-0 lg:ml-4">
            <h2 className="text-white uppercase">COMPANY JOIN REQUESTS</h2>
            <Card shadowColor="yellow" className="p-4 text-center">
              <CompanyApprovalList />
            </Card>
          </div>
        </div>
        <div className="flex flex-1">
          <div className="flex-1 pb-24">
            <div className="flex flex-col mx-4 my-4 space-y-2 lg:mr-4 lg:ml-0">
              <h2 className="text-white uppercase">COMPANY MEMBERS</h2>

              <Card shadowColor="yellow" className="p-4 text-center">
                <CompanyMemberList showRemove />
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminApprovalPage;
